/*
 * Copyright (c) 2023 CalAmp Corp. All Rights Reserved
 */
import React, {PropsWithChildren} from 'react';
import {makeStyles} from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  form : {
    padding : '20px 35px',
    height  : 'calc(100% - 40px)'
  }
}));

/**
 * Re-usable form component for maintaining consistent padding inside of embedded forms.
 */
export const EmbeddedForm = ({children}: PropsWithChildren) => {
  const classes = useStyles();
  return (
    <div className={classes.form}>
      {children}
    </div>
  );
};

export default EmbeddedForm;
